export const gridStyle = {
  height: 400,
  width: '100%',
  '--ag-border-color': 'transparent',
  '--ag-row-border-color': 'transparent',
  '--ag-header-background-color': 'rgba(243, 244, 246, 1)',
  '--ag-odd-row-background-color': 'rgba(243, 244, 246, 1)',
  '--ag-even-row-background-color': '#FFFFFF'
};
